var ComponentGlobals = {
    ignoreResize: false
};
export { ComponentGlobals };
